<nav>
	<button
		type="button"
		matRipple
		[matRippleColor]="'rgb(255 255 255 / 16%)'"
		(click)="onNavigateToHome()"
		[class.active]="visibleItem() === null"
	>
		<home-icon />
	</button>
	<button
		type="button"
		matRipple
		[matRippleColor]="'rgb(255 255 255 / 16%)'"
		(click)="onShowOptions()"
		[class.active]="visibleItem() === 'NAV'"
	>
		<corepark-white-icon />
	</button>
	<button
		type="button"
		matRipple
		[matRippleColor]="'rgb(255 255 255 / 16%)'"
		(click)="onShowUser()"
		[class.active]="visibleItem() === 'USER'"
	>
		<user-icon />
	</button>
</nav>
@if (visible()) {
	<div class="container" @SlideUpDown>
		@if (visibleItem() === 'NAV') {
			<div class="options-container">
				@for (option of options; track option.path) {
					<a
						[routerLink]="option.path"
						class="anchor-option"
						routerLinkActive="active"
						[routerLinkActiveOptions]="{ exact: true }"
					>
						{{ option.label }}
					</a>
				}
			</div>
		}

		@if (visibleItem() === 'USER') {
			<div class="location-container">
				<span>
					<small>Welcome</small>
					<strong>{{ locationName() }}</strong>
				</span>
				<button type="button" (click)="signOut()">Sign out</button>
			</div>
		}
	</div>
}
